import { type CollectionChainType, type Item, type LineupItemResponse } from '@app/client';
import { type GameItemData } from '@app/pages/FantasyWishlist/sections/LeaderboardSection/types';

import { type ResourceId } from '../general';
import { type PagingParams } from '../requests';
import {
    type IWishlist,
    type WishlistCollectionParam,
    type WishlistItem,
    type WishlistType,
} from '../wishlists/wishlists';

import { type Competition, type DynamicCriteriaType } from './competitions';

export enum SubmissionState {
    Submitted = 'Submitted',
    Pending = 'Pending',
}

export interface WishlistLineupItem extends Partial<Omit<WishlistItem, 'item'>>, Omit<LineupItemResponse, 'item'> {
    item: Partial<WishlistCollectionParam> & Partial<Item>;
}
export interface CompetitionWishlistItem extends Omit<IWishlist, 'items'> {
    competition: Competition;
    contents_modified_at: Date;
    items: WishlistLineupItem[];
    wishlist_type: WishlistType;
    thumbnailAssets?: string[];
}

export type LeaderboardCollection = [string, number, CollectionChainType];

export interface LeaderboardItem {
    profit?: number;
    budget_usd?: number;
    current_value?: number;
    submission_value?: number;
    collections?: LeaderboardCollection[];
    item_count?: number;
    wishlist_name?: string;
    wishlist_id: ResourceId;
    competition_wishlist_id: ResourceId;
    user_id: ResourceId;
    rank?: number;
    primary_yat?: string;
    username?: string;
    primary_yat_heading?: string;
    twitter_handle?: string | null;
    submitted_at?: string;
    submitted?: boolean;
    team_id: string;
}

export type TeamMemberItem = {
    team_id?: string;
    primary_yat?: string;
    wishlist_id?: ResourceId;
    primary_yat_heading?: string;
    username?: string;
    user_id: ResourceId;
    twitter_handle?: string | null;
};

export type TeamLeaderboardItem = Partial<
    Pick<LeaderboardItem, 'profit' | 'current_value' | 'user_id' | 'rank' | 'submission_value'>
> & {
    competition_id?: string;
    team_id?: string;
    team_name?: string;
    collection_samples?: string[];
    team_description?: string;
    rank?: number;
    submission_value?: number;
    current_value?: number;
    profit?: number;
    members?: GameItemData[];
};

export interface CompetitionLeaderboardResponse {
    data: LeaderboardItem[];
    paging: PagingParams;
}

export type CompetitionCollectionAvailabilityItem = {
    is_valid: boolean;
    evaluated_criteria: DynamicCriteriaType;
    current_state: DynamicCriteriaType;
};

export interface CompetitionCollectionAvailability {
    [slug: string]: CompetitionCollectionAvailabilityItem;
}
export type CompetitionCollectionAvailabilityResponse = {
    dynamic_criteria: CompetitionCollectionAvailability;
};
